export const closeDisplayAlbum = () => ({
  type: "CLOSE_DISPLAY_ALBUM"
});

export const openDisplayAlbum = () => ({
  type: "OPEN_DISPLAY_ALBUM"
});

export const fetchAlbum = resp => ({
  type: "FETCH_ALBUM",
  payload: resp
});

export const setCurrentAlbum = album => ({
  type: "SET_CURRENT_ALBUM",
  payload: album
});

export const setSelectedMedia = media => ({
  type: "SET_SELECTED_MEDIA",
  payload: media
});



// WEBPACK FOOTER //
// ./src/actions/actions/display-album.js